import * as Types from '../../../../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

/*
* This was automatically generated on by @graphql-codegen.
* DO NOT MANUALLY EDIT !!!
* Please refer to https://github.com/wistia/wistia/blob/main/frontend/graphql/README.md for more information.
* Last Updated: Thu Apr 17 2025 02:17:50 GMT+0000 (Coordinated Universal Time)
*/

const defaultOptions = {} as const;
export type CurrentContactQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentContactQuery = { __typename?: 'Query', currentContact?: { __typename?: 'Contact', id: string, name?: string | null | undefined, email: string, initials: string, avatar?: { __typename?: 'Avatar', id: string, thumbnailUrl?: string | null | undefined } | null | undefined } | null | undefined };


export const CurrentContactDocument = gql`
    query CurrentContact {
  currentContact {
    id
    name
    email
    initials
    avatar {
      id
      thumbnailUrl
    }
  }
}
    `;

/**
 * __useCurrentContactQuery__
 *
 * To run a query within a React component, call `useCurrentContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentContactQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentContactQuery(baseOptions?: Apollo.QueryHookOptions<CurrentContactQuery, CurrentContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentContactQuery, CurrentContactQueryVariables>(CurrentContactDocument, options);
      }
export function useCurrentContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentContactQuery, CurrentContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentContactQuery, CurrentContactQueryVariables>(CurrentContactDocument, options);
        }
export function useCurrentContactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentContactQuery, CurrentContactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentContactQuery, CurrentContactQueryVariables>(CurrentContactDocument, options);
        }
export type CurrentContactQueryHookResult = ReturnType<typeof useCurrentContactQuery>;
export type CurrentContactLazyQueryHookResult = ReturnType<typeof useCurrentContactLazyQuery>;
export type CurrentContactSuspenseQueryHookResult = ReturnType<typeof useCurrentContactSuspenseQuery>;
export type CurrentContactQueryResult = Apollo.QueryResult<CurrentContactQuery, CurrentContactQueryVariables>;